import React, { useState, useEffect } from 'react';
import { ApiProgressLoader } from '@nile/components';
import { CircleProgress } from 'react-gradient-progress';

function UploadDownloadLoading({ isCompleted, primaryColor, secondaryColor }) {
  let [percentage, setPercentage] = useState(0);
  let [isLoadingCompleted, setIsLoadingCompleted] = useState(false);

  let defaultPrimaryColor = ['#45A9F1', '#2346FF'];
  let defaultSecondaryColor = '#E7E7F7';

  useEffect(() => {
    let interval = setTimeout(() => {
      if (percentage < 90) {
        setPercentage((percentage) => percentage + 1);
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let interval = setTimeout(() => {
      if (percentage < 90) {
        setPercentage((percentage) => percentage + 1);
      }
    }, 100);
    return () => clearInterval(interval);
  }, [percentage]);

  useEffect(() => {
    if (isCompleted) {
      setPercentage(100);
      setTimeout(() => {
        setIsLoadingCompleted(true);
      }, 500);
    }
  }, [isCompleted]);

  return (
    <div className="flex-item-balloon flex-center f-16 text-medium">
      {!isLoadingCompleted ? (
        !Number.isNaN(percentage) ? (
          <CircleProgress
            percentage={percentage}
            width={25}
            strokeWidth={2}
            primaryColor={primaryColor || defaultPrimaryColor}
            secondaryColor={secondaryColor || defaultSecondaryColor}
            fontSize={0}
          />
        ) : (
          'NA'
        )
      ) : (
        <ApiProgressLoader isSuccess={isLoadingCompleted} />
      )}
    </div>
  );
}

export default UploadDownloadLoading;
